module.exports = __webpack_public_path__ + "media/images/bnr_header_discount_sp-d4426776ff5b920d5d4b3323a75cc7ce.jpg";